// extracted by mini-css-extract-plugin
module.exports = {"marker":"_2xA0tK","dot":"rWgJVy","animateDot":"_231yWO","wave":"_2neurf","wave2":"_3jIDmN","animationWave":"_2UBUdB","pin":"_2eiyum"};